var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('RequestKitsThanksHero',{attrs:{"header":"REQUEST KITS","paragraph":"Thank you for your request. Our sun safety squad will get right on it. Please allow 4–6 weeks for your kits to arrive.","image":"Super-Sam-SunHero-300-large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }